(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-image"] && !Shopify.designMode) return;
  try {
    // Handle lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll('.responsive-image img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // If image is already loaded, show it immediately
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            // Otherwise wait for load event
            img.addEventListener('load', function() {
              img.classList.add('loaded');
            });
            
            // Fallback: if load event doesn't fire, show after a delay
            setTimeout(() => {
              if (!img.classList.contains('loaded')) {
                img.classList.add('loaded');
              }
            }, 1000);
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feefo-product-stars"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__feefoStarsScrollBound) return;
    window.__feefoStarsScrollBound = true;

    document.addEventListener('click', (event) => {
      const stars = event.target.closest('[data-scroll-to-reviews]');
      if (!stars) return;

      const reviews = document.getElementById('feefo-product-review-widgetId');
      if (!reviews) return;

      event.preventDefault();
      event.stopPropagation();

      const details = reviews.closest('details');
      if (details) details.open = true;

      const headerOffset =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        ) || 0;
      const target = details || reviews;
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 12;

      window.scrollTo({ top, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
